<template>
  <div class="bar-wrapper">
    <section v-for="(config, index) in stepList" :key="config.value" class="bar-item" :class="{ 'is-active': config.value === status }">
      <span class="step">{{ config.step }}</span>
      <span class="text">{{ config.text }}</span>
      <span v-if="index + 1 !== stepList.length" class="divide-line" />
    </section>
  </div>
</template>

<script>
import { APPEAL_STATUS } from './const'

const stepList = [
  {
    step: '1',
    text: '草稿状态',
    value: APPEAL_STATUS.DRAFT.code
  },
  {
    step: '2',
    text: '申诉待受理',
    value: APPEAL_STATUS.UNREVIEWED.code
  },
  {
    step: '3',
    text: '申诉处理中',
    value: APPEAL_STATUS.ACCEPTANCE.code
  },
  {
    step: '4',
    text: '申诉确权中',
    value: APPEAL_STATUS.DEALING.code
  },
  {
    step: '5',
    text: '已完结',
    value: APPEAL_STATUS.FINISHED.code
  },
  {
    step: 'X',
    text: '驳回',
    value: APPEAL_STATUS.REJECT.code
  },
  {
    step: 'X',
    text: '已取消',
    value: APPEAL_STATUS.CANCELEED.code
  },
]

export default {
  name: 'StatusBar',
  props: {
    status: {
      type: Number,
      default: APPEAL_STATUS.DRAFT.code
    }
  },
  data() {
    return {
      stepList
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #F6F8F9;

  .bar-item {
    display: flex;
    align-items: center;
    color: #999;
    font-size: 14px;

    .step {
      width: 35px;
      height: 35px;
      border-radius: 35px;
      border: 1px solid #D1D3D3;
      font-size: 18px;
      color: #E3E5E6;
      text-align: center;
      line-height: 32px;
    }

    .text {
      margin-left: 8px;
    }
    &.is-active {
      .step {
        border-color: transparent;
        background-color: #1890FF;
        color: #fff;
        font-weight: bold;
      }

      .text {
        font-size: 16px;
        color: #666;
        font-weight: bold;
      }
    }
    .divide-line {
      width: 24px;
      height: 1px;
      background-color: #E7E7E7;
      margin: 0 12px;
    }
  }
}
</style>
